module.exports = __webpack_public_path__ + "static/img/userbg44.208d4e81.png";